"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationTypes = exports.DRM_TYPE = void 0;
var DRM_TYPE;
(function (DRM_TYPE) {
    DRM_TYPE["PLAYREADY"] = "com.microsoft.playready";
    DRM_TYPE["WIDEVINE"] = "com.widevine.alpha";
    DRM_TYPE["CLEARKEY"] = "org.w3.clearkey";
    DRM_TYPE["FAIRPLAY"] = "com.apple.fps";
    DRM_TYPE["FAIRPLAY_1"] = "com.apple.fps.1_0";
    DRM_TYPE["FAIRPLAY_2"] = "com.apple.fps.2_0";
    DRM_TYPE["FAIRPLAY_3"] = "com.apple.fps.3_0";
})(DRM_TYPE || (exports.DRM_TYPE = DRM_TYPE = {}));
var IntegrationTypes;
(function (IntegrationTypes) {
    IntegrationTypes["DRMToday"] = "drmtoday";
    IntegrationTypes["Axinom"] = "axinom";
    IntegrationTypes["Azure"] = "azure";
    IntegrationTypes["Comcast"] = "comcast";
    IntegrationTypes["Vualto"] = "vualto";
})(IntegrationTypes || (exports.IntegrationTypes = IntegrationTypes = {}));
//# sourceMappingURL=ISourceDrm.js.map